var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('expense-table',{attrs:{"heading":'Expenses for '+_vm.$store.employee.first_name+' '+_vm.$store.employee.last_name,"show-user":false,"show-job":true,"editable":true,"filtering-tools":true,"filters":[
			['user_id',_vm.$store.employee.id]
		]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }